import { tw } from "@/utils";
import { AcceptanceStatus, statusMap } from "../types";

interface InsightStatusLabelProps {
  status: AcceptanceStatus;
}

export const InsightStatusLabel = (props: InsightStatusLabelProps) => {
  const { status } = props;

  return (
    <div
      className={tw(
        colorMap[status],
        "relative flex items-center justify-center w-[100px] h-[28px] rounded-[20px]",
        "text-sm font-semibold",
        "border-solid border-[1px]"
      )}
    >
      {statusMap[status]}
    </div>
  );
};

const colorMap: Record<AcceptanceStatus, string> = {
  in_progress: tw("bg-gray-g10 border-gray-g75 text-gray-g200"),
  accepted: tw("bg-green/5 border-green text-green"),
  rejected: tw("bg-red/5 border-red text-red"),
  canceled: tw("bg-gray-g30 border-gray-g30 text-gray-g100"),
  transfer_confirmed: tw("bg-purple-100/10 border-purple-100 text-purple-100"),
  transfer_completed: tw("bg-purple-100/10 border-purple-100 text-purple-100"),
};
